import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

interface ReviewPanelHeaderProps {
  breadcrumb: string;
  status?: string;
}

export default function ReviewPanelHeader({ breadcrumb, status }: ReviewPanelHeaderProps) {
  const navigate = useNavigate();
  return (
    <div className="mt-review-page__header">
      <button className="mt-review-page__back" onClick={() => navigate("/my-todos")}>
        <ChevronLeft size={16} /> Back
      </button>
      <div className="mt-review-page__breadcrumb">{breadcrumb}</div>
      {status && <div className="mt-review-page__status-pill">{status}</div>}
    </div>
  );
}
